<template>
    <div class="messages">
        <transition-group name="fade" tag="div" class="messagesContainer">
            <div v-for="message in getMessageLastItem" :key="message.id" :class="[ message.success ? 'message-success' : 'message-fail' ]" class="message">{{ message.text }}</div>
        </transition-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Messages',
    computed: {
        ...mapGetters(['messages']),
        getMessageLastItem() {
            return this.messages.slice(-2)
        }
    },
}
</script>
<style lang="scss" scoped>
.messages {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    justify-content: center;
    z-index: 9;
    @media screen and (min-width: 768px) {
        top: 0;
    }
    .messagesContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        flex-direction: column-reverse;
        @media screen and (min-width: 768px) {
            flex-direction: column;
        }
    }
}
.message {
    min-width: 300px;
    text-align: center;
    padding: .5rem 0;
    margin: 0.5rem 0 0 0;
    border: 1px solid transparent;
    border-radius: .25rem;
    white-space: pre-line;
    @media screen and (min-width: 768px) {
        min-width: 500px;
        margin: 0 0 0.5rem 0;
    }
    &.message-success {
        color: #000000;
        background-color: rgba(212, 237, 218, 0.6);
        border-color: #c3e6cb;
    }
    &.message-fail {
        color: #ffffff;
        font-size: large;
        background-color: rgba(255, 32, 50, 0.6);
        border-color: #f5c6cb;
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.fade-move {
    transition: transform 3s;
}
</style>